<div class="common-lateral-panel"
  [ngClass]="{'common-lateral-panel--expand':boxProtection.fullScreen}">
  <div class="common-section-title__lp-container">
    <div class="common-section-title__lp-title-icon">
      <i [class]="boxProtection.icon + ' common-icon__lg'"></i>
      <span class="common-section-title__lp-label-text"
        [afTranslate]="boxProtection.title"></span>
    </div>
  </div>
  <div class="common-lateral-panel__body-protection">
    <div class="common-lateral-panel__subtitle-protection"
      [afTranslate]="boxProtection.subTitle">
    </div>
    <div class="common-lateral-panel__body-text-protection"
      [ngClass]="{'common-lateral-panel__body-text-protection--minimized': !boxProtection.fullScreen}"
      [id]="'box-protection-'+boxProtection.id"
      [innerHTML]="data">
    </div>
  </div>
  @if(boxProtection.fullScreen || showMoreInfo()){
    <div class="common-lateral-panel__expand-block-right">
      <button class="common-button__expand-toned"
        (click)="boxProtection.fullScreen = !boxProtection.fullScreen">
        <i class=" common-icon__md"
          [ngClass]="boxProtection.fullScreen? 'lf-icon-angle-up': 'lf-icon-angle-down'"></i>
        <span class="common-button__expand-label-text"
          [afTranslate]="boxProtection.fullScreen?'common.collapse':'common.expand'"></span>
      </button>
    </div>
  }
</div>
